import { create } from "zustand";
import { XPHistoryEntry } from "../api/rewards/types";

interface XPHistoryState {
  // Data
  entries: XPHistoryEntry[];
  totalCount: number;
  hasMore: boolean;
  currentOffset: number;

  // Loading states
  isLoading: boolean;
  isLoadingMore: boolean;

  // Error state
  error: string | null;

  // Internal methods (prefixed with _)
  _setEntries: (entries: XPHistoryEntry[]) => void;
  _appendEntries: (entries: XPHistoryEntry[]) => void;
  _setTotalCount: (count: number) => void;
  _setHasMore: (hasMore: boolean) => void;
  _setCurrentOffset: (offset: number) => void;
  _setLoading: (loading: boolean) => void;
  _setLoadingMore: (loading: boolean) => void;
  _setError: (error: string | null) => void;
  _reset: () => void;
}

const initialState = {
  entries: [],
  totalCount: 0,
  hasMore: false,
  currentOffset: 0,
  isLoading: false,
  isLoadingMore: false,
  error: null,
};

export const useXPHistoryStore = create<XPHistoryState>((set) => ({
  ...initialState,

  // Setters
  _setEntries: (entries) => set({ entries }),
  _appendEntries: (newEntries) =>
    set((state) => ({ entries: [...state.entries, ...newEntries] })),
  _setTotalCount: (totalCount) => set({ totalCount }),
  _setHasMore: (hasMore) => set({ hasMore }),
  _setCurrentOffset: (currentOffset) => set({ currentOffset }),
  _setLoading: (isLoading) => set({ isLoading }),
  _setLoadingMore: (isLoadingMore) => set({ isLoadingMore }),
  _setError: (error) => set({ error }),
  _reset: () => set(initialState),
}));
